/* packages/volto-wildcard-theme/src/components/Blocks/HPBestServices/view.jsx */
import React from 'react';
import HPBestServices from './HPBestServices';

const View = () => <HPBestServices />;

export default View;